<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Jugadores"   />

    <Players />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Players from "@/components/Pages/Admin/Players/index.vue";

export default defineComponent({
  name: "PlayerPage",
  components: {
    PageTitle,
    Players,
  },
});
</script>
